import { useQuery } from 'react-query'; 
import axiosInstance from './axiosInstance';

const fetchClientsStats = async () => {
  const response = await axiosInstance.get('/super-admin/client-management/stats');
  return response.data;
};

export const useGetClientsStats = () => {
  return useQuery('client-stats', fetchClientsStats); 
};
